export type KeycloakObserver = (keycloak: any) => void;
class KeycloakPubService {
    private ready = false;
    private keycloak: any;
    private listeners: KeycloakObserver[] = []

    public subscribe(listener: KeycloakObserver) {
        this.listeners.push(listener);
        if (this.ready)
            listener(this.keycloak);
    }
    public unbsubscribe(listener: KeycloakObserver) {
        this.listeners = this.listeners.filter(c => c !== listener);
    }

    public updateKeycloak(keycloak: any) {
        this.keycloak = keycloak;
        this.ready = true;
        this.notify(keycloak);
    }
    private notify(keycloak: any) {
        this.listeners.forEach(listener => listener(keycloak));
    }
}
const KeycloakPubServiceInstance = new KeycloakPubService()

export default KeycloakPubServiceInstance;